<template>
  <gj-modal
    size="normal"
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    padding20
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>新增标签分类</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="135px">
        <el-form-item
          label="分类名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请输入分类名称',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <gj-input
            v-model="form.name"
            class="form-input"
            width="250px"
            placeholder="请输入分类名称"
            maxlength="40"
          ></gj-input>
          <!-- show-word-limit -->
        </el-form-item>
        <el-form-item label="上级分类" prop="parentId">
          <gj-tree-select
            v-model="form.parentId"
            :data="treeData"
            class="form-input"
            :clearable="false"
            width="250px"
            placeholder="请选择上级分类"
            ref="editTree"
          ></gj-tree-select>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  responseMixin,
  formRuleMixin,
} from "../../../../../minxins";
import { tagCategoryAdd, fourToTreeList } from "../../../../../api/system";

export default {
  name: "app-tag-group-add-modal",
  mixins: [modalMixIn, responseMixin, formRuleMixin],
  props: {
    selectData: null,
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        name: null,
        parentId: null,
      },
      treeData: [],
      loading: false,
    };
  },
  created() {
    this.queryData();
    if (this.selectData) {
      this.form.parentId = this.selectData.id;
    }
  },
  methods: {
    queryData() {
      this.loading = true;
      fourToTreeList()
        .then((res) => {
          this.treeData = res.data;
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
        this.confirmLoading = true;
        const levelNew = this.$refs.editTree.currentData.level;
        const levelOld = this.selectData && this.selectData.level;
        let levelFin = 0;
        if (this.selectData && this.form.parentId === this.selectData.id) {
          levelFin = levelOld;
        } else {
          levelFin = levelNew;
        }
        const params = {
          name: this.form.name,
          fid: this.form.parentId,
          level: this.form.parentId ? parseFloat(levelFin) + 1 : 1,
        };
        tagCategoryAdd(params)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("新增标签成功");
              this.$emit("created");
              this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
          });
      }
    },
  },
};
</script>

<style scoped>
.form-input {
}
</style>
